// extracted by mini-css-extract-plugin
module.exports = {"heading":"NFTDrawer_heading__YPifX","nftList":"NFTDrawer_nftList__iPbxB","container":"NFTDrawer_container__dEoPT","nftIcon":"NFTDrawer_nftIcon__244Yu"};